/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface DebugInformation {
  beoPremiumIndex: number;
  beoPriceValueIndex: number;
  offerRankingRank: number;
  offerRankingScore: number;
  availableSupplier: string;
  supplierOfferId: string;
  processToken: string;
  leisureOfferKey: string;
  specialOfferId: string;
  services: string;
  tourOperatorRemarks: string;
  vacancyOfferData: string;
  brandCode: string;
  roomIdList: string;
  alternativeFlightsGroupHash: string;
  upsellingGroupHash: string;
  bookingUpsellingGroupHash: string;
  compareHash: string;
  enteringTheBoxHash: string;
  price?: DebugInformation_Price;
  roomTypePrediction: string[];
  offerSource: string;
}

export interface DebugInformation_Price {
  isAggressiveMinGrossPriceUsed: boolean;
  isDynamicPrice: boolean;
  oldAmount: number;
  packagePrice: number;
  aggressiveMinPrice: number;
  minTotalAmount: number;
  maxTotalAmount: number;
  internalMaxPrice: number;
  internalCompetitivePrice: number;
  dynamicPricingOffset: number;
  pricingType: string;
  dynamicPricingCompareHash: string;
  daIntern: string;
  competitor?: DebugInformation_Price_Competitor;
}

export interface DebugInformation_Price_Competitor {
  price: number;
  offerId: string;
  tourOperator: string;
}

function createBaseDebugInformation(): DebugInformation {
  return {
    beoPremiumIndex: 0,
    beoPriceValueIndex: 0,
    offerRankingRank: 0,
    offerRankingScore: 0,
    availableSupplier: "",
    supplierOfferId: "",
    processToken: "",
    leisureOfferKey: "",
    specialOfferId: "",
    services: "",
    tourOperatorRemarks: "",
    vacancyOfferData: "",
    brandCode: "",
    roomIdList: "",
    alternativeFlightsGroupHash: "",
    upsellingGroupHash: "",
    bookingUpsellingGroupHash: "",
    compareHash: "",
    enteringTheBoxHash: "",
    price: undefined,
    roomTypePrediction: [],
    offerSource: "",
  };
}

export const DebugInformation = {
  encode(
    message: DebugInformation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.beoPremiumIndex !== 0) {
      writer.uint32(104).sint32(message.beoPremiumIndex);
    }
    if (message.beoPriceValueIndex !== 0) {
      writer.uint32(112).sint32(message.beoPriceValueIndex);
    }
    if (message.offerRankingRank !== 0) {
      writer.uint32(160).sint32(message.offerRankingRank);
    }
    if (message.offerRankingScore !== 0) {
      writer.uint32(157).float(message.offerRankingScore);
    }
    if (message.availableSupplier !== "") {
      writer.uint32(10).string(message.availableSupplier);
    }
    if (message.supplierOfferId !== "") {
      writer.uint32(18).string(message.supplierOfferId);
    }
    if (message.processToken !== "") {
      writer.uint32(26).string(message.processToken);
    }
    if (message.leisureOfferKey !== "") {
      writer.uint32(34).string(message.leisureOfferKey);
    }
    if (message.specialOfferId !== "") {
      writer.uint32(42).string(message.specialOfferId);
    }
    if (message.services !== "") {
      writer.uint32(50).string(message.services);
    }
    if (message.tourOperatorRemarks !== "") {
      writer.uint32(58).string(message.tourOperatorRemarks);
    }
    if (message.vacancyOfferData !== "") {
      writer.uint32(66).string(message.vacancyOfferData);
    }
    if (message.brandCode !== "") {
      writer.uint32(74).string(message.brandCode);
    }
    if (message.roomIdList !== "") {
      writer.uint32(90).string(message.roomIdList);
    }
    if (message.alternativeFlightsGroupHash !== "") {
      writer.uint32(122).string(message.alternativeFlightsGroupHash);
    }
    if (message.upsellingGroupHash !== "") {
      writer.uint32(130).string(message.upsellingGroupHash);
    }
    if (message.bookingUpsellingGroupHash !== "") {
      writer.uint32(138).string(message.bookingUpsellingGroupHash);
    }
    if (message.compareHash !== "") {
      writer.uint32(146).string(message.compareHash);
    }
    if (message.enteringTheBoxHash !== "") {
      writer.uint32(170).string(message.enteringTheBoxHash);
    }
    if (message.price !== undefined) {
      DebugInformation_Price.encode(
        message.price,
        writer.uint32(98).fork()
      ).ldelim();
    }
    for (const v of message.roomTypePrediction) {
      writer.uint32(82).string(v!);
    }
    if (message.offerSource !== "") {
      writer.uint32(178).string(message.offerSource);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DebugInformation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDebugInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 13:
          message.beoPremiumIndex = reader.sint32();
          break;
        case 14:
          message.beoPriceValueIndex = reader.sint32();
          break;
        case 20:
          message.offerRankingRank = reader.sint32();
          break;
        case 19:
          message.offerRankingScore = reader.float();
          break;
        case 1:
          message.availableSupplier = reader.string();
          break;
        case 2:
          message.supplierOfferId = reader.string();
          break;
        case 3:
          message.processToken = reader.string();
          break;
        case 4:
          message.leisureOfferKey = reader.string();
          break;
        case 5:
          message.specialOfferId = reader.string();
          break;
        case 6:
          message.services = reader.string();
          break;
        case 7:
          message.tourOperatorRemarks = reader.string();
          break;
        case 8:
          message.vacancyOfferData = reader.string();
          break;
        case 9:
          message.brandCode = reader.string();
          break;
        case 11:
          message.roomIdList = reader.string();
          break;
        case 15:
          message.alternativeFlightsGroupHash = reader.string();
          break;
        case 16:
          message.upsellingGroupHash = reader.string();
          break;
        case 17:
          message.bookingUpsellingGroupHash = reader.string();
          break;
        case 18:
          message.compareHash = reader.string();
          break;
        case 21:
          message.enteringTheBoxHash = reader.string();
          break;
        case 12:
          message.price = DebugInformation_Price.decode(
            reader,
            reader.uint32()
          );
          break;
        case 10:
          message.roomTypePrediction.push(reader.string());
          break;
        case 22:
          message.offerSource = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DebugInformation {
    return {
      beoPremiumIndex: isSet(object.beoPremiumIndex)
        ? Number(object.beoPremiumIndex)
        : 0,
      beoPriceValueIndex: isSet(object.beoPriceValueIndex)
        ? Number(object.beoPriceValueIndex)
        : 0,
      offerRankingRank: isSet(object.offerRankingRank)
        ? Number(object.offerRankingRank)
        : 0,
      offerRankingScore: isSet(object.offerRankingScore)
        ? Number(object.offerRankingScore)
        : 0,
      availableSupplier: isSet(object.availableSupplier)
        ? String(object.availableSupplier)
        : "",
      supplierOfferId: isSet(object.supplierOfferId)
        ? String(object.supplierOfferId)
        : "",
      processToken: isSet(object.processToken)
        ? String(object.processToken)
        : "",
      leisureOfferKey: isSet(object.leisureOfferKey)
        ? String(object.leisureOfferKey)
        : "",
      specialOfferId: isSet(object.specialOfferId)
        ? String(object.specialOfferId)
        : "",
      services: isSet(object.services) ? String(object.services) : "",
      tourOperatorRemarks: isSet(object.tourOperatorRemarks)
        ? String(object.tourOperatorRemarks)
        : "",
      vacancyOfferData: isSet(object.vacancyOfferData)
        ? String(object.vacancyOfferData)
        : "",
      brandCode: isSet(object.brandCode) ? String(object.brandCode) : "",
      roomIdList: isSet(object.roomIdList) ? String(object.roomIdList) : "",
      alternativeFlightsGroupHash: isSet(object.alternativeFlightsGroupHash)
        ? String(object.alternativeFlightsGroupHash)
        : "",
      upsellingGroupHash: isSet(object.upsellingGroupHash)
        ? String(object.upsellingGroupHash)
        : "",
      bookingUpsellingGroupHash: isSet(object.bookingUpsellingGroupHash)
        ? String(object.bookingUpsellingGroupHash)
        : "",
      compareHash: isSet(object.compareHash) ? String(object.compareHash) : "",
      enteringTheBoxHash: isSet(object.enteringTheBoxHash)
        ? String(object.enteringTheBoxHash)
        : "",
      price: isSet(object.price)
        ? DebugInformation_Price.fromJSON(object.price)
        : undefined,
      roomTypePrediction: Array.isArray(object?.roomTypePrediction)
        ? object.roomTypePrediction.map((e: any) => String(e))
        : [],
      offerSource: isSet(object.offerSource) ? String(object.offerSource) : "",
    };
  },

  toJSON(message: DebugInformation): unknown {
    const obj: any = {};
    message.beoPremiumIndex !== undefined &&
      (obj.beoPremiumIndex = Math.round(message.beoPremiumIndex));
    message.beoPriceValueIndex !== undefined &&
      (obj.beoPriceValueIndex = Math.round(message.beoPriceValueIndex));
    message.offerRankingRank !== undefined &&
      (obj.offerRankingRank = Math.round(message.offerRankingRank));
    message.offerRankingScore !== undefined &&
      (obj.offerRankingScore = message.offerRankingScore);
    message.availableSupplier !== undefined &&
      (obj.availableSupplier = message.availableSupplier);
    message.supplierOfferId !== undefined &&
      (obj.supplierOfferId = message.supplierOfferId);
    message.processToken !== undefined &&
      (obj.processToken = message.processToken);
    message.leisureOfferKey !== undefined &&
      (obj.leisureOfferKey = message.leisureOfferKey);
    message.specialOfferId !== undefined &&
      (obj.specialOfferId = message.specialOfferId);
    message.services !== undefined && (obj.services = message.services);
    message.tourOperatorRemarks !== undefined &&
      (obj.tourOperatorRemarks = message.tourOperatorRemarks);
    message.vacancyOfferData !== undefined &&
      (obj.vacancyOfferData = message.vacancyOfferData);
    message.brandCode !== undefined && (obj.brandCode = message.brandCode);
    message.roomIdList !== undefined && (obj.roomIdList = message.roomIdList);
    message.alternativeFlightsGroupHash !== undefined &&
      (obj.alternativeFlightsGroupHash = message.alternativeFlightsGroupHash);
    message.upsellingGroupHash !== undefined &&
      (obj.upsellingGroupHash = message.upsellingGroupHash);
    message.bookingUpsellingGroupHash !== undefined &&
      (obj.bookingUpsellingGroupHash = message.bookingUpsellingGroupHash);
    message.compareHash !== undefined &&
      (obj.compareHash = message.compareHash);
    message.enteringTheBoxHash !== undefined &&
      (obj.enteringTheBoxHash = message.enteringTheBoxHash);
    message.price !== undefined &&
      (obj.price = message.price
        ? DebugInformation_Price.toJSON(message.price)
        : undefined);
    if (message.roomTypePrediction) {
      obj.roomTypePrediction = message.roomTypePrediction.map((e) => e);
    } else {
      obj.roomTypePrediction = [];
    }
    message.offerSource !== undefined &&
      (obj.offerSource = message.offerSource);
    return obj;
  },

  fromPartial(object: DeepPartial<DebugInformation>): DebugInformation {
    const message = createBaseDebugInformation();
    message.beoPremiumIndex = object.beoPremiumIndex ?? 0;
    message.beoPriceValueIndex = object.beoPriceValueIndex ?? 0;
    message.offerRankingRank = object.offerRankingRank ?? 0;
    message.offerRankingScore = object.offerRankingScore ?? 0;
    message.availableSupplier = object.availableSupplier ?? "";
    message.supplierOfferId = object.supplierOfferId ?? "";
    message.processToken = object.processToken ?? "";
    message.leisureOfferKey = object.leisureOfferKey ?? "";
    message.specialOfferId = object.specialOfferId ?? "";
    message.services = object.services ?? "";
    message.tourOperatorRemarks = object.tourOperatorRemarks ?? "";
    message.vacancyOfferData = object.vacancyOfferData ?? "";
    message.brandCode = object.brandCode ?? "";
    message.roomIdList = object.roomIdList ?? "";
    message.alternativeFlightsGroupHash =
      object.alternativeFlightsGroupHash ?? "";
    message.upsellingGroupHash = object.upsellingGroupHash ?? "";
    message.bookingUpsellingGroupHash = object.bookingUpsellingGroupHash ?? "";
    message.compareHash = object.compareHash ?? "";
    message.enteringTheBoxHash = object.enteringTheBoxHash ?? "";
    message.price =
      object.price !== undefined && object.price !== null
        ? DebugInformation_Price.fromPartial(object.price)
        : undefined;
    message.roomTypePrediction = object.roomTypePrediction?.map((e) => e) || [];
    message.offerSource = object.offerSource ?? "";
    return message;
  },
};

function createBaseDebugInformation_Price(): DebugInformation_Price {
  return {
    isAggressiveMinGrossPriceUsed: false,
    isDynamicPrice: false,
    oldAmount: 0,
    packagePrice: 0,
    aggressiveMinPrice: 0,
    minTotalAmount: 0,
    maxTotalAmount: 0,
    internalMaxPrice: 0,
    internalCompetitivePrice: 0,
    dynamicPricingOffset: 0,
    pricingType: "",
    dynamicPricingCompareHash: "",
    daIntern: "",
    competitor: undefined,
  };
}

export const DebugInformation_Price = {
  encode(
    message: DebugInformation_Price,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isAggressiveMinGrossPriceUsed === true) {
      writer.uint32(32).bool(message.isAggressiveMinGrossPriceUsed);
    }
    if (message.isDynamicPrice === true) {
      writer.uint32(80).bool(message.isDynamicPrice);
    }
    if (message.oldAmount !== 0) {
      writer.uint32(13).float(message.oldAmount);
    }
    if (message.packagePrice !== 0) {
      writer.uint32(21).float(message.packagePrice);
    }
    if (message.aggressiveMinPrice !== 0) {
      writer.uint32(29).float(message.aggressiveMinPrice);
    }
    if (message.minTotalAmount !== 0) {
      writer.uint32(45).float(message.minTotalAmount);
    }
    if (message.maxTotalAmount !== 0) {
      writer.uint32(53).float(message.maxTotalAmount);
    }
    if (message.internalMaxPrice !== 0) {
      writer.uint32(69).float(message.internalMaxPrice);
    }
    if (message.internalCompetitivePrice !== 0) {
      writer.uint32(77).float(message.internalCompetitivePrice);
    }
    if (message.dynamicPricingOffset !== 0) {
      writer.uint32(109).float(message.dynamicPricingOffset);
    }
    if (message.pricingType !== "") {
      writer.uint32(90).string(message.pricingType);
    }
    if (message.dynamicPricingCompareHash !== "") {
      writer.uint32(98).string(message.dynamicPricingCompareHash);
    }
    if (message.daIntern !== "") {
      writer.uint32(114).string(message.daIntern);
    }
    if (message.competitor !== undefined) {
      DebugInformation_Price_Competitor.encode(
        message.competitor,
        writer.uint32(58).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DebugInformation_Price {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDebugInformation_Price();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.isAggressiveMinGrossPriceUsed = reader.bool();
          break;
        case 10:
          message.isDynamicPrice = reader.bool();
          break;
        case 1:
          message.oldAmount = reader.float();
          break;
        case 2:
          message.packagePrice = reader.float();
          break;
        case 3:
          message.aggressiveMinPrice = reader.float();
          break;
        case 5:
          message.minTotalAmount = reader.float();
          break;
        case 6:
          message.maxTotalAmount = reader.float();
          break;
        case 8:
          message.internalMaxPrice = reader.float();
          break;
        case 9:
          message.internalCompetitivePrice = reader.float();
          break;
        case 13:
          message.dynamicPricingOffset = reader.float();
          break;
        case 11:
          message.pricingType = reader.string();
          break;
        case 12:
          message.dynamicPricingCompareHash = reader.string();
          break;
        case 14:
          message.daIntern = reader.string();
          break;
        case 7:
          message.competitor = DebugInformation_Price_Competitor.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DebugInformation_Price {
    return {
      isAggressiveMinGrossPriceUsed: isSet(object.isAggressiveMinGrossPriceUsed)
        ? Boolean(object.isAggressiveMinGrossPriceUsed)
        : false,
      isDynamicPrice: isSet(object.isDynamicPrice)
        ? Boolean(object.isDynamicPrice)
        : false,
      oldAmount: isSet(object.oldAmount) ? Number(object.oldAmount) : 0,
      packagePrice: isSet(object.packagePrice)
        ? Number(object.packagePrice)
        : 0,
      aggressiveMinPrice: isSet(object.aggressiveMinPrice)
        ? Number(object.aggressiveMinPrice)
        : 0,
      minTotalAmount: isSet(object.minTotalAmount)
        ? Number(object.minTotalAmount)
        : 0,
      maxTotalAmount: isSet(object.maxTotalAmount)
        ? Number(object.maxTotalAmount)
        : 0,
      internalMaxPrice: isSet(object.internalMaxPrice)
        ? Number(object.internalMaxPrice)
        : 0,
      internalCompetitivePrice: isSet(object.internalCompetitivePrice)
        ? Number(object.internalCompetitivePrice)
        : 0,
      dynamicPricingOffset: isSet(object.dynamicPricingOffset)
        ? Number(object.dynamicPricingOffset)
        : 0,
      pricingType: isSet(object.pricingType) ? String(object.pricingType) : "",
      dynamicPricingCompareHash: isSet(object.dynamicPricingCompareHash)
        ? String(object.dynamicPricingCompareHash)
        : "",
      daIntern: isSet(object.daIntern) ? String(object.daIntern) : "",
      competitor: isSet(object.competitor)
        ? DebugInformation_Price_Competitor.fromJSON(object.competitor)
        : undefined,
    };
  },

  toJSON(message: DebugInformation_Price): unknown {
    const obj: any = {};
    message.isAggressiveMinGrossPriceUsed !== undefined &&
      (obj.isAggressiveMinGrossPriceUsed =
        message.isAggressiveMinGrossPriceUsed);
    message.isDynamicPrice !== undefined &&
      (obj.isDynamicPrice = message.isDynamicPrice);
    message.oldAmount !== undefined && (obj.oldAmount = message.oldAmount);
    message.packagePrice !== undefined &&
      (obj.packagePrice = message.packagePrice);
    message.aggressiveMinPrice !== undefined &&
      (obj.aggressiveMinPrice = message.aggressiveMinPrice);
    message.minTotalAmount !== undefined &&
      (obj.minTotalAmount = message.minTotalAmount);
    message.maxTotalAmount !== undefined &&
      (obj.maxTotalAmount = message.maxTotalAmount);
    message.internalMaxPrice !== undefined &&
      (obj.internalMaxPrice = message.internalMaxPrice);
    message.internalCompetitivePrice !== undefined &&
      (obj.internalCompetitivePrice = message.internalCompetitivePrice);
    message.dynamicPricingOffset !== undefined &&
      (obj.dynamicPricingOffset = message.dynamicPricingOffset);
    message.pricingType !== undefined &&
      (obj.pricingType = message.pricingType);
    message.dynamicPricingCompareHash !== undefined &&
      (obj.dynamicPricingCompareHash = message.dynamicPricingCompareHash);
    message.daIntern !== undefined && (obj.daIntern = message.daIntern);
    message.competitor !== undefined &&
      (obj.competitor = message.competitor
        ? DebugInformation_Price_Competitor.toJSON(message.competitor)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DebugInformation_Price>
  ): DebugInformation_Price {
    const message = createBaseDebugInformation_Price();
    message.isAggressiveMinGrossPriceUsed =
      object.isAggressiveMinGrossPriceUsed ?? false;
    message.isDynamicPrice = object.isDynamicPrice ?? false;
    message.oldAmount = object.oldAmount ?? 0;
    message.packagePrice = object.packagePrice ?? 0;
    message.aggressiveMinPrice = object.aggressiveMinPrice ?? 0;
    message.minTotalAmount = object.minTotalAmount ?? 0;
    message.maxTotalAmount = object.maxTotalAmount ?? 0;
    message.internalMaxPrice = object.internalMaxPrice ?? 0;
    message.internalCompetitivePrice = object.internalCompetitivePrice ?? 0;
    message.dynamicPricingOffset = object.dynamicPricingOffset ?? 0;
    message.pricingType = object.pricingType ?? "";
    message.dynamicPricingCompareHash = object.dynamicPricingCompareHash ?? "";
    message.daIntern = object.daIntern ?? "";
    message.competitor =
      object.competitor !== undefined && object.competitor !== null
        ? DebugInformation_Price_Competitor.fromPartial(object.competitor)
        : undefined;
    return message;
  },
};

function createBaseDebugInformation_Price_Competitor(): DebugInformation_Price_Competitor {
  return { price: 0, offerId: "", tourOperator: "" };
}

export const DebugInformation_Price_Competitor = {
  encode(
    message: DebugInformation_Price_Competitor,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.price !== 0) {
      writer.uint32(13).float(message.price);
    }
    if (message.offerId !== "") {
      writer.uint32(18).string(message.offerId);
    }
    if (message.tourOperator !== "") {
      writer.uint32(26).string(message.tourOperator);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): DebugInformation_Price_Competitor {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDebugInformation_Price_Competitor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.price = reader.float();
          break;
        case 2:
          message.offerId = reader.string();
          break;
        case 3:
          message.tourOperator = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DebugInformation_Price_Competitor {
    return {
      price: isSet(object.price) ? Number(object.price) : 0,
      offerId: isSet(object.offerId) ? String(object.offerId) : "",
      tourOperator: isSet(object.tourOperator)
        ? String(object.tourOperator)
        : "",
    };
  },

  toJSON(message: DebugInformation_Price_Competitor): unknown {
    const obj: any = {};
    message.price !== undefined && (obj.price = message.price);
    message.offerId !== undefined && (obj.offerId = message.offerId);
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DebugInformation_Price_Competitor>
  ): DebugInformation_Price_Competitor {
    const message = createBaseDebugInformation_Price_Competitor();
    message.price = object.price ?? 0;
    message.offerId = object.offerId ?? "";
    message.tourOperator = object.tourOperator ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
